/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {routes as Éµa} from './app/app.routes';